import {baseEntityRules, naicIdRules, pbmIdRules} from "./EntityValidators";

export const updateEntityValidationRules = (existingEntities = []) => ({
    ...baseEntityRules,
    pbmId: pbmIdRules(existingEntities),
    naicId: naicIdRules(existingEntities),
});
